<template>
    <div>
        <van-sticky>
            <van-nav-bar
                    title="送货单查询"
                    left-arrow
                    @click-left="back()"
            />
            <div class="keyboard" style="background-color: #ffffff">
                <h5 style="text-align: left;padding: 10px 30px;margin: 0">请输入车牌号码：</h5>
                <div class="input-box" @click="clickShowKeyboard">
                    <li>{{first}}</li>
                    <li>{{numArr[0]}}</li>
                    <li>{{numArr[1]}}</li>
                    <li>{{numArr[2]}}</li>
                    <li>{{numArr[3]}}</li>
                    <li>{{numArr[4]}}</li>
                    <li>{{numArr[5]}}</li>
                    <li>{{numArr[6]}}</li>
                </div>
                <div style="text-align: center;">
                    <van-button icon="search" type="info" native-type="submit" class="button" @click="onSearch()">
                        查询
                    </van-button>
                </div>
                <!-- 选择车牌号 首个汉字键盘 弹出层 -->
                <div class="plate_number">
                    <van-popup
                            v-model="show_chinese"
                            position="bottom"
                            :overlay="true"
                            overlay-class="displayNone"
                    >
                        <div class="plate_chinese_box">
                            <!-- 点击对应的汉字，进行输入 -->
                            <van-button
                                    size="small"
                                    v-for="(item, index) in ChineseList"
                                    :key="item.id"
                                    @click="checkChinese(index)"
                            >{{item.name}}
                            </van-button>
                            <div class="close-box" @click.stop="close_keyboard">
                                <div>×</div>
                                <li></li>
                            </div>
                        </div>
                    </van-popup>
                </div>
                <!-- 英文 数字 键盘 -->
                <div class="allBoard">
                    <van-popup
                            v-model="show_allBoard"
                            position="bottom"
                            :overlay="true"
                            overlay-class="displayNone"
                    >
                        <div class="plate_number_box">
                            <!-- 点击对应的字母或数字，进行输入 -->
                            <van-button
                                    size="small"
                                    v-for="(item, index) in English_Number"
                                    :key="item.id"
                                    @click="checkEnglish_num(index)"
                            >{{item.name}}
                            </van-button>
                            <div class="close-box" @click.stop="close_keyboard">
                                <div>╳</div>
                                <li></li>
                            </div>
                        </div>
                    </van-popup>
                </div>
            </div>
        </van-sticky>
        <div class="contentwarp" style="height: calc(100vh - 255px); overflow: auto" v-if='isFirstClick'>
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" >
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <div style="margin-top: 0" v-for="item in outnotifyList" :key="item.outnotifyId">
                        <div class="van-doc-demo-block">
                            <div class="van-cell-group van-hairline--bottom">
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>单号</span></div>
                                    <div class="van-cell__value"><span>{{item.outnotifyNo}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>货主</span></div>
                                    <div class="van-cell__value"><span>{{item.customerName}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>车号</span></div>
                                    <div class="van-cell__value"><span>{{item.deliveryTrucknumber}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>仓库</span></div>
                                    <div class="van-cell__value"><span>{{item | formatWcode}}</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>数量</span></div>
                                    <div class="van-cell__value">
                                        <span>{{item.totalAmount}}件/{{item.totalWeight}}公斤</span></div>
                                </div>
                                <div class="van-cell">
                                    <div class="van-cell__title"><span>创建时间</span></div>
                                    <div class="van-cell__value"><span>{{item.createTime | moment("YYYY-MM-DD")}}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
        <!--<div class="van-address-list__bottom">
            <van-button block type="info" native-type="submit" class="button" @click="onSearch()">
                关闭
            </van-button>
        </div>-->
    </div>
</template>

<script>
    import {NavBar, Cell, Button, Toast, Icon, Field, Collapse, CollapseItem} from 'vant';
    import {List} from 'vant';
    import {Search} from 'vant';
    import {Col, Row} from 'vant';
    import {SwipeCell} from 'vant';
    import {Popup} from 'vant';
    import {PullRefresh} from 'vant';
    import {Sticky} from 'vant';
    import {RadioGroup, Radio} from 'vant';
    import {Calendar} from 'vant';
    import service from '../../server/index'
    import {Image as VanImage} from 'vant';
    import {ImagePreview} from 'vant';
    import {resCode} from "../../utils/tools";

    export default {
        name: "MyOut",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
        },
        data() {
            return {
                key: "",
                outnotifyList: [],
                page: 1,
                limit: 10,
                finished: true,
                loading: true,
                isLoading: false,
                showKeyboard: true,    //车牌号输入框是否聚焦
                show_chinese: false,     //是否显示汉字键盘
                show_allBoard: false,     //是否显示英文数字键盘
                ChineseList: [
                    {name: '京', id: 1},
                    {name: '津', id: 2},
                    {name: '冀', id: 3},
                    {name: '晋', id: 4},
                    {name: '蒙', id: 5},
                    {name: '辽', id: 6},
                    {name: '吉', id: 7},
                    {name: '黑', id: 8},
                    {name: '沪', id: 9},
                    {name: '苏', id: 10},
                    {name: '浙', id: 11},
                    {name: '皖', id: 12},
                    {name: '闽', id: 13},
                    {name: '赣', id: 14},
                    {name: '鲁', id: 15},
                    {name: '豫', id: 16},
                    {name: '鄂', id: 17},
                    {name: '湘', id: 18},
                    {name: '粤', id: 19},
                    {name: '桂', id: 20},
                    {name: '琼', id: 21},
                    {name: '渝', id: 22},
                    {name: '川', id: 23},
                    {name: '贵', id: 24},
                    {name: '云', id: 25},
                    {name: '藏', id: 26},
                    {name: '陕', id: 27},
                    {name: '甘', id: 28},
                    {name: '青', id: 29},
                    {name: '宁', id: 30},
                    {name: '新', id: 31},
                    {name: '←', id: 99},
                ],
                English_Number: [
                    {name: '1', id: 28},
                    {name: '2', id: 29},
                    {name: '3', id: 30},
                    {name: '4', id: 31},
                    {name: '5', id: 32},
                    {name: '6', id: 33},
                    {name: '7', id: 34},
                    {name: '8', id: 35},
                    {name: '9', id: 36},
                    {name: '0', id: 37},
                    {name: 'Q', id: 38},
                    {name: 'W', id: 39},
                    {name: 'E', id: 40},
                    {name: 'R', id: 41},
                    {name: 'T', id: 42},
                    {name: 'Y', id: 43},
                    {name: 'U', id: 44},
                    {name: 'I', id: 45},
                    {name: 'O', id: 46},
                    {name: 'P', id: 47},
                    {name: 'A', id: 48},
                    {name: 'S', id: 49},
                    {name: 'D', id: 50},
                    {name: 'F', id: 51},
                    {name: 'G', id: 52},
                    {name: 'H', id: 53},
                    {name: 'J', id: 54},
                    {name: 'K', id: 55},
                    {name: 'L', id: 56},
                    {name: 'Z', id: 57},
                    {name: 'X', id: 58},
                    {name: 'C', id: 59},
                    {name: 'V', id: 60},
                    {name: 'B', id: 61},
                    {name: 'N', id: 62},
                    {name: 'M', id: 63},
                    {name: '←', id: 99},
                ],
                first: '',
                numArr: [],
                appid: '',
                isFirstClick: false,
            };
        },
        mounted() {
            this.close_keyboard();
        },
        computed: {},
        filters: {
            formatWcode(item) {
                let appid = process.env.VUE_APP_OUTNOTIFY_APPID
                console.log(appid)
                return item.cangWcode

                /*if (this.appid == 'absn') {
                    return item.cangWcode
                } else {
                    return item.wcode
                }*/
            },
        },
        methods: {
            back() {
                this.$router.replace("/Home/HomeMenuTh")
            },
            onSearch() {
                this.isFirstClick = true;
                this.outnotifyList = [];
                this.page = 1;
                this.close_keyboard();
                this.onLoad();
            },
            onRefresh() {
                this.close_keyboard();
                this.onLoad();
            },
            onLoad() {
                let param = {}
                param.limit = 10
                param.page = this.page
                let numStr = ''
                this.numArr.map(it => {
                    numStr += it
                })
                param.key2 = this.first + numStr
                param.status = 10
                let router = ''
                console.log(param)
                service.getRoute({appid: process.env.VUE_APP_OUTNOTIFY_APPID}).then(data => {
                // service.getRoute({appid: 'a003'}).then(data => {
                    if (data.code == resCode.success) {
                        router = data.data.urlHost
                        service.selJGOutNotifyPForWechat(router, param).then(res => {
                            if (res.code == resCode.success) {
                                if (res.data != null && res.data.length > 0) {
                                    for (let i = 0; i < res.data.length; i++) {
                                        this.outnotifyList.push(res.data[i]);
                                    }
                                    this.page++
                                } else {
                                    this.finished = true;
                                }
                                // 加载状态结束
                                this.loading = false;
                                this.isLoading = false;
                            } else {
                                this.loading = false;
                                this.finished = true;
                                this.isLoading = false;
                                Toast(res.msg)
                            }

                        }).catch((res) => {
                            this.loading = false;
                            this.finished = true;
                            Toast(res.msg)
                        });
                    } else {
                        Toast(data.msg)
                    }
                })
            },
            // 唤起键盘
            clickShowKeyboard() {
                if (!this.first) {
                    this.show_chinese = true;
                } else {
                    this.show_chinese = false;
                    this.show_allBoard = true;
                }
            },
            // 选择车牌号前面的汉字
            checkChinese(index) {
                // 如果点击删除键，删除第一个格的内容
                if (this.ChineseList[index].id == 99) {
                    this.first = ''
                } else {
                    // 把选中的字赋值给第一个格，并且切换键盘
                    this.first = this.ChineseList[index].name;
                    this.show_chinese = false;
                    this.show_allBoard = true;
                }
            },
            // 选择车牌号后面的数字和字母
            checkEnglish_num(index) {
                // 如果点击删除键，删除 numArr 的最后一个值
                if (this.English_Number[index].id == 99) {
                    this.numArr.pop()
                    // 如果 numArr 里面被删的没有值了，切换键盘
                    if (this.numArr.length == 0) {
                        this.show_chinese = true;
                        this.show_allBoard = false;
                    }
                } else {
                    if (this.numArr.length < 7) {
                        // 把选中的值 push 到 numArr 内
                        this.numArr.push(this.English_Number[index].name)
                    }
                }
            },
            // 关闭虚拟键盘
            close_keyboard() {
                this.show_chinese = false;
                this.show_allBoard = false;
            }
        }
    }
</script>

<style scoped>
    .van-cell {

    }

    .van-popup {
        background-color: #f7f8fa;
    }

    .searchwarp {
        margin-top: 46px;
    }

    .editwarp {
        width: 100%;
        margin: 56px auto;
    }

    .qrcode {
        margin: 10px auto; /* 居中 这个是必须的，，其它的属性非必须 */
        width: 180px; /* 给个宽度 顶到浏览器的两边就看不出居中效果了 */
        text-align: center; /* 文字等内容居中 */
    }

    /*.swipewarp{*/
    /*    height: 100px;*/
    /*}*/

    .contentwarp {
        height: calc(100vh - 50px);
    }

    /*/deep/ .van-ellipsis{*/
    /*    color: #EE0A24;*/
    /*}*/
    /*/deep/ .van-nav-bar .van-icon{*/
    /*    color: #EE0A24;*/
    /*}*/

    /*/deep/ .van-nav-bar__text{*/
    /*    color: #EE0A24;*/
    /*}*/
    .closebutton {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 50px;
        height: 50px;
        width: 100% !important;
    }

    .closebutton2 {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        z-index: 9999;
    }

    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }

    /deep/ .van-button--info,
    /deep/ .van-button--danger {
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color: #6685a4;

    }

    /deep/ .van-button--warning {
        background-color: #6685a4;
        border: 1px solid #6685a4;

    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end,
    /deep/ .detailHeader[data-v-1405fac1] {
        background-color: #6685a4;
    }

    /deep/ .van-calendar__day--middle {
        background-color: #e4ebf3;
    }


    .cellwarp {
        padding-top: 0px;
        padding-bottom: 0px;
        font-weight: bolder;
        padding-left: 0px;
    }

    .cellitemwarp {
        padding-top: 8px;
        padding-bottom: 8px;
    }

    a {
        color: #6685a4;;
    }

    .van-doc-demo-block__title {
        margin: 0;
        padding: 15px 16px 10px 16px;
        color: rgba(69, 90, 100, 0.6);
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
    }

    /deep/ .van-cell__title {
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex: unset;
        flex: unset;
        width: 90px;
        color: #969799;
    }

    /deep/ .van-cell__value {
        color: #323233;
    }

    /deep/ .yqsm .van-cell__value {
        text-align: left;
    }

    .van-doc-demo-block {
        margin-bottom: 8px;
    }

    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 40px;
        width: 150px;
    }

    .van-address-list__bottom {
        position: fixed;
        bottom: 50px;
        left: 0;
        z-index: 999;
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
        background-color: #fff;
    }

</style>

<style scoped lang="scss">
    .keyboard {
        width: 100%;
    }

    // 车牌号 & 虚拟键盘
    .input-box {
        width: 21rem;
        height: 3.2rem;
        margin: auto;
        background: rgba(255, 255, 255, 1);
        /*box-shadow:0px 6px 8px 0px rgba(96,100,112,0.1);*/
        border-radius: .4rem;
        border: 1px solid rgba(206, 208, 210, 1);
        margin: 0 auto 12px;
        display: flex;
        justify-content: center;

        li {
            flex: 1;
            border-right: 1px solid rgba(206, 208, 210, 1);
            box-sizing: border-box;
            margin-left: -1px;
            font-size: 1.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #323233;
        }

        li:last-child {
            border: none;
        }
    }

    .class-close-box {
        width: 2rem;
        height: 1.5rem;
        position: absolute;
        right: 0.5rem;
        top: -1.5rem;
    }

    .class-close-box-div {
        width: 1.5rem;
        height: 1.5rem;
        font-size: 1.8rem;
        line-height: 1.7rem;
        margin: auto;
        text-align: center;
        border: 1px solid #666;
        border-radius: 50%;
        color: #fff;
        background: #6685a4;
    }

    .class-close-box-li {
        width: 1px;
        height: 0.5rem;
        background: #666;
        margin: auto;
    }

    .overflow-y {
        overflow-y: inherit;
    }

    .class-van-button-small {
        min-width: 0;
        border-radius: 5px;
        margin: 5px 2px;
        box-shadow: 5px 5px 5px #aaa;
    }

    .class-plate-box {
        width: 100%;
        padding: 0.7rem 0.5rem;
        box-sizing: border-box;
        background: #eaf1f9;
        position: relative;
    }

    .plate_number {
        .van-popup {
            @extend .overflow-y;
        }

        .van-popup--bottom {
            background: #eee;
        }

        .plate_chinese_box {
            width: 100%;
            @extend .class-plate-box;

            .close-box {
                @extend .class-close-box;

                div {
                    @extend .class-close-box-div;
                }

                li {
                    @extend .class-close-box-li;
                }
            }

            .van-button--small {
                width: 11.3%;
                height: 3.5rem;
                @extend .class-van-button-small;
            }
        }
    }

    .allBoard {
        .van-popup {
            @extend .overflow-y;
        }

        .plate_number_box {
            width: 100%;
            @extend .class-plate-box;

            .close-box {
                @extend .class-close-box;

                div {
                    @extend .class-close-box-div;
                }

                li {
                    @extend .class-close-box-li;
                }
            }

            .van-button--small {
                width: 8.8%;
                height: 3rem;
                @extend .class-van-button-small;
            }

            .van-button--small:nth-child(1) {
                margin-bottom: 5px;
            }

            .van-button--small:nth-child(21) {
                margin-left: 5%;
            }

            .van-button--small:nth-child(30) {
                margin-left: 10%;
            }

            .van-button--small:last-child {
                width: 13%;
            }
        }
    }
</style>
<style lang="scss">
    .displayNone {
        display: none !important;
    }
</style>
